<template>
	<!-- @cell-dblclick="dblclick" 双击功能暂时关闭 -->
	<el-table :data="tableData" border style="width: 100%" :cell-class-name="cellClassName">
		<el-table-column v-for="(item,index) in tabList" :key="index" :prop="item.prop" align="center"
			header-align="center" :label="item.label" :width="item.width" show-overflow-tooltip>
		</el-table-column>
		<slot></slot>
		<!-- <el-table-column fixed="right" align="center" header-align="center" label="动作" width="120">
			<template slot-scope="scope">
				<el-button v-if="status == 'check'" @click="handleClick(scope.row,'查看')" type="text" size="small">查看
				</el-button>
				<el-button v-if="status == ''" @click="handleClick(scope.row,'编辑')" type="text" size="small">编辑
				</el-button>
				<el-button v-if="status == ''" type="text" size="small" @click="handleClick(scope.row,'删除')">删除
				</el-button>
			</template>
		</el-table-column> -->
	</el-table>
</template>

<script>
	export default {
		data() {
			return {
				tableData: this.outTable,
				tabList: this.outTabList,
				// 存一份旧值，用于校验是否发生变化，是否修改
				oldCellValue: null
			}
		},
		props: {
			status: {
				type: String,
				default: ''
			},
			// 外部数据
			outTable: {
				type: Array,
				default: () => []
			},
			// 外部表头
			outTabList: {
				type: Array,
				default: () => []
			}
		},
		methods: {
			setTableData(data) {
				this.tableData = data
			},
			// 新增
			addTable() {
				this.tableData.push({})
			},
			handleClick(row, type) {
				if (type == '删除') {
					this.tableData.splice(row.index, 1)
				}
				this.$emit('editMore', [row.index, type])
			},
			cellClassName({
				row,
				// column,
				rowIndex,
				// columnIndex
			}) {
				row.index = rowIndex; // 自定义指定一个索引，下方能够用到
			},
		},
	}
</script>

<style>

</style>
